module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('Promo_Press', {

		configure: function () {
			this.blocksDimmensions = {};
			this.activeLink = '';

			this.registerOptions('', {
				'embed.container': '.common-content',
				template: 'promo_press',
				autoRender: true,

				widgets: {
					postsDl: {
						widget: 'Datalayer',
						method: 'McBlog.get',
						limit: 3,
						fields: ['id', 'publishDate', 'shortContent.content', 'shortContent.type', 'title', 'rating.voters', 'commentsSum.total'],
						transitParameters: {
							status: 2,
							yearSort: 2014,
							lang: fox.i18n.lang
						},
						'handleWom.dataLoad': {
							event: 'loaded',
							widget: '@this',
							callback: '@parent:_handleDlLoad'
						}
					},

					postList: {
						widget: 'List',
						container: '.press-blog-post .items',
						autoRender: false,
						'tpl.row': 'press_post_item'
					},

					fileRequest: {
						widget: 'Faq_Question',
						autoRender: true,
						container: '.request',
						template: 'press_file_request'
					},

					mailChimpApi: {
						widget: 'Api',
						method: 'subscription.subscribe'
					},

					copyright: {
						widget: 'Copyright'
					}
				},

				'handleWom.showSuccessMessage': {
					widget: '#mailChimpApi',
					event: 'success',
					callback: 'showSubscriptionMessage'
				},
				'handleWom.showErrorMessage': {
					widget: '#mailChimpApi',
					event: 'failure',
					callback: 'showSubscriptionMessage'
				},
				'handleWom.successFileRequest': {
					widget: '#fileRequest',
					event: 'success',
					callback: 'clearForm'
				},

				'handlers.openMobileMenu': {
					target: '.open-mobile-menu-link',
					event: 'click',
					callback: fox.bind(function (el, alias, w, e) {
						/*var el = fox.dom.wrap(el);
						var menu = fox.dom.wrap(this.dom1('#promo-top-menu'));

						el.hide();
						menu.addClass('showed');*/

						fox.dom.addClass('show', el);
					}, this)
				},
				'handlers.toggleMobileMenu': {
					target: '.close-mobile-menu-link',
					event: 'click',
					callback: fox.bind(function (el, alias, w, e) {
						var openLink = this.dom1('.open-mobile-menu-link');
						/*var menu = fox.dom.wrap(this.dom1('#promo-top-menu'));

						openLink.node().style.display = '';
						menu.removeClass('showed');*/
						fox.dom.removeClass('show', openLink);
					}, this)
				},
				'handlers.subscribe': {
					target: '.subscribe',
					event: 'click',
					callback: 'subscribe'
				},

				'hooks.onAddedToDom': 'getPosts'
			});
			
			this.callParent('configure', arguments);
		},

		running: function () {
			this.postList = this.rwom1('#postList');
			this.postsDl = this.rwom1('#postsDl');

			this.callParent('running', arguments);
			window.scrollTo(0,0);
		},

		activate: function (argument) {
			this.callParent('activate', arguments);

			window.scrollTo(0,0);
		},

		getPosts: function () {
			this.postsDl.load();
		},

		_handleDlLoad: function (obj, dl) {
			this.postList.setCollection(dl.getCollection(), true);
		},

		showSubscriptionMessage: function (resp, api, event) {
			var block = fox.dom.wrap(this.dom1('.subscribe-message'));

			if (!block) {
				return;
			}

			block.html(event === 'success' ? 'Thank you for your subscription!' : resp.answer.reason);
			block.addClass('show');
			this.clearForm();


			window.setTimeout(function () {
				block.removeClass('show');
			}, 2000);
		},

		subscribe: function () {
			var isAllowed = true;
			var data = {};
			var fields = fox.dom.select('.subscribe-block .inp', this.element);

			if (fields.length) {
				fox.each(fields, function (input) {
					var value = fox.trim(input.value);
					if (value.length === 0) {
						isAllowed = false;
						return false;
					}
					data[input.name] = input.value;
				});
			}

			if (!isAllowed) {
				return;
			}

			this.rwom1('#mailChimpApi').send(data);

		},

		clearForm: function () {
			var fields = fox.dom.select('.request-form .fields2send', this.element);

			if (fields.length) {
				fox.each(fields, function (input) {
					input.value = '';
				});
			}
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/press/press.js
// module id = 469
// module chunks = 2